// extracted by mini-css-extract-plugin
export default {"item":"z-draggable_item__NK85O","item__drag-handle":"z-draggable_item__drag-handle__N5vov"};